import React from "react";
import "./Snackbar.css";
const Snackbar = (props) => {
  return <div id="snackbar" style={{ backgroundColor: props.color }}>{props.msg}</div>;
};

export default Snackbar;
